import axios from 'axios';
import axiosInstance from "@/axios";
// import {axios, axiosInstance} from 'axios';
import Swal from 'sweetalert2';
import router from '@/router';

export const state = {
  token: localStorage.getItem('token') || null,
  tokenType: localStorage.getItem('token_type') || null,
  expiration: localStorage.getItem('expiration') || null,
  email: localStorage.getItem('email') || null,
  password: localStorage.getItem('password') || null,

  loggedUser:  localStorage.getItem('loggedUser')  || null,  
}

export const getters = {
  isTokenExpired(state) {
    
    return Date.now() > state.expiration;
  },
  loggedUser: state => state.loggedUser,

  token: state => state.token
}

export const mutations = {
  setAuthData(state, { token, tokenType, expiration, email, password, loggedUser}) {
    state.token = token;
    state.tokenType = tokenType;
    state.expiration = expiration;
    state.email = email;
    state.password = password;
    state.loggedUser = loggedUser;

    localStorage.setItem('token', token);
    localStorage.setItem('token_type', tokenType);
    localStorage.setItem('expiration', expiration);
    localStorage.setItem('email', email);
    localStorage.setItem('password', password);
    localStorage.setItem('loggedUser', JSON.stringify(loggedUser));
  },

  clearAuthData(state) {
    state.token = null;
    state.tokenType = null;
    state.expiration = null;
    state.email = null;
    state.password = null;
    state.loggedUser = null;

    localStorage.removeItem('token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('expiration');
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    localStorage.removeItem('loggedUser');
  },

  setToken(state, token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
}
 

export const actions = {
  async login({ commit }, { email, password }) {
    try {
      const response = await axios.post("/api/v1/portal/login", { email, password }); 

      const { token, token_type, expiration, candidate } = response.data;

      const expirationTimestamp = Date.now() + expiration * 1000;
      commit('setAuthData', { token, tokenType: token_type, expiration: expirationTimestamp, email, password, loggedUser: candidate });
      router.push({ name: 'dashboard' });
    } catch (error) {
      const errorMessage = error.response ? error.response.data.message : "Ein unerwarteter Fehler ist aufgetreten.";
      Swal.fire("Fehler bei der Anmeldung!", errorMessage, "error"); 
    }
  },
 

  async register(_, newCandidate) {
    try {
      const response = await axios.post("/api/v1/portal/register", newCandidate);
      const { data } = response;

      return data.data.id;
    } catch (error) {
      

      const errorMessage = error.response && error.response.data && error.response.data.message 
            ? error.response.data.message 
            : "Ein unerwarteter Fehler ist aufgetreten.";
  
      throw new Error(errorMessage);
    }
  },


  
  async updateCandidate(_, candidateData) {
    try {
      await axiosInstance({ requiresAuth: true }).patch("/api/v1/portal/profile", candidateData);
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.message 
        ? error.response.data.message 
        : "Ein unerwarteter Fehler ist aufgetreten.";
  
      throw new Error(errorMessage);
    }
  },

  async refreshToken({ commit, state }) {
    console.log('inside refresh token')
    try {
      const response = await axios.post("/api/v1/portal/refresh-token", {
        email: state.email,
        password: state.password,
      });

      const { token, expiration } = response.data;
      const expirationTimestamp = Date.now() + expiration * 1000;
      commit('setToken', token, expirationTimestamp);
    } catch (error) {
      Swal.fire("Sitzung abgelaufen", "Bitte melden Sie sich erneut an.", "warning").then(()=>{
        commit('clearAuthData');
      });
    }
  },

  logout({ commit }) {
    commit('clearAuthData');
    Swal.fire("Abgemeldet.", "Sie wurden erfolgreich abgemeldet.", "info").then(()=>{
      router.push({ name: 'login' });
    });
  }
}

export default {
  namespaced: true,  
  state,
  getters,
  mutations,
  actions,
};